import { z } from 'zod';

export const osInfoSchema = z.object({
    machine: z.string().optional(),
    nodename: z.string().optional(),
    release: z.string().optional(),
    sysname: z.string().optional(),
    version: z.string().optional(),
});

export type OSInfo = z.infer<typeof osInfoSchema>;

export const connectedDeviceInfoSchema = z.object({
    board: z.string(),
    frequency: z.number(),
    language: z.string(),
    os_info: osInfoSchema,
    unique_id: z.union([z.string(), z.array(z.number())]),
    version: z.string(),
});

export type ConnectedDeviceInfo = z.infer<typeof connectedDeviceInfoSchema>;

export const connectedDeviceInfoValueSchema = z.union([
    z.string(),
    z.number(),
    z.instanceof(Uint8Array),
]);

export type ConnectedDeviceInfoValue = z.infer<
    typeof connectedDeviceInfoValueSchema
>;
